import { AudioPreview } from 'src/pages/CommunityDetails/Posts/components/audioPreview'
import UnsupportedContent from 'src/pages/CommunityDetails/Posts/PostConsumption/UnsupportedContent'
import { ImagePreview } from 'src/pages/CommunityDetails/Posts/components/imagePreview'
import { PdfPreview } from 'src/pages/CommunityDetails/Posts/components/pdfPreview'
import { useUser } from 'src/hook/useUser'
import { CommentType } from '../../postComments.types'
import { MediaPreviewProps } from './mediaPreview.types'

const MediaPreview = ({ comment, postId }: MediaPreviewProps) => {
  const { isOwner } = useUser()
  const shouldRenderUnsuportedContent = comment.type === CommentType.VIDEO && isOwner

  if (shouldRenderUnsuportedContent) {
    return <UnsupportedContent />
  }

  switch (comment.type) {
    case CommentType.IMAGE:
      return (
        <ImagePreview
          newsId={postId}
          commentId={comment.id}
          mediaHeight={comment.mediaHeight}
          mediaWidth={comment.mediaWidth}
        />
      )

    case CommentType.DOCUMENT:
      return (
        <PdfPreview
          newsId={postId}
          commentId={comment.id}
          fileName={comment.fileName}
          contentLength={comment.contentLength}
          pagesCount={comment.pagesCount}
          thumbnailUrl={comment.thumbnailUrl}
        />
      )

    case CommentType.AUDIO:
      return <AudioPreview commentId={comment.id} />

    default:
      return null
  }
}

export default MediaPreview
